import React from 'react';
import styled from 'styled-components';
import { SUCCESS, WARNING, ERROR, CONTRAST } from '../../theme';

const MeterSVG = styled.svg`
  background: transparent;
  fill: transparent;
  transform: rotate(126deg);
  transition: stroke-dasharray 0.3s ease;
`;

const Container = styled.div`
  text-align: center;
  position: relative;
`;

const Value = styled.div`
  line-height: 1.4;
  color: ${CONTRAST};
  margin-top: ${({ radius }) => radius / 2}px;
  font-weight: bold;
  font-size: ${({ radius }) => radius}px;
  position: absolute;
  left: 0;
  right: 0;
`;

const Labels = styled.p`
  margin-top: -${({ topOffset }) => topOffset}px;
  font-weight: bold;
  font-size: 12px;
`;

const getCircumference = (r) => 2 * Math.PI * r;
const convertPercentToDashArray = (percent, total) =>
  ((percent * total) / 100) * 0.8;

const Circle = styled.circle`
  stroke: ${({ percent, inverted }) => {
    if (inverted) {
      if (percent > 66) return ERROR;
      if (percent > 33) return WARNING;
      return SUCCESS;
    }

    if (percent > 66) return SUCCESS;
    if (percent > 33) return WARNING;
    return ERROR;
  }};
  stroke-width: 10;
  stroke-dasharray: ${({ percent, r }) => {
    const total = getCircumference(r);
    return `${convertPercentToDashArray(percent, total)}, ${total}`;
  }};
`;

const BgCircle = styled.circle`
  stroke: #e5e5e5;
  stroke-width: 10;
  stroke-dasharray: ${({ r }) => {
    const total = getCircumference(r);
    return `${convertPercentToDashArray(100, total)}, ${total}`;
  }};
`;

export const Meter = ({ radius = 55, total, value, inverted = false }) => {
  const percent = (value / total) * 100;
  const wrapperDimensions = radius * 2.4;
  const circleDimension = radius * 1.2;

  return (
    <Container>
      <Value radius={radius}>{value}</Value>
      <MeterSVG height={wrapperDimensions} width={wrapperDimensions}>
        <BgCircle r={radius} cx={circleDimension} cy={circleDimension} />
        <Circle
          percent={percent}
          r={radius}
          cx={circleDimension}
          cy={circleDimension}
          inverted={inverted}
        />
      </MeterSVG>
      <Labels topOffset={radius / 3}>{`0 - ${total}`}</Labels>
    </Container>
  );
};
